export const PATHS = {
  MY_SKILLS: "my-skills",
  SKILL_COMPARISON: "skill-comparison",
  TIME_INVESTMENT: "time-investment",
  JOB_SKILLS: "/jobs-and-skills/*",
};
